import { ACTION_TYPES } from 'src/constants';
import { INITIAL_STATE } from '../store';

export default function ProductReducer(state = INITIAL_STATE.product, action) {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_PRODUCT: {
      return {
        ...action.payload,
      };
    }

    // PRODUCT
    case ACTION_TYPES.REQUEST_PRODUCT_DETAIL: {
      return state;
    }

    case ACTION_TYPES.PRODUCT_LIST_SUCCESS: {
      return { ...state, productList: action.payload.products };
    }

    case ACTION_TYPES.REQUEST_PRODUCT_DETAIL_SUCCEEDED: {
      return { ...state, productDetail: action.payload };
    }

    case ACTION_TYPES.REQUEST_PRODUCT_DETAIL_FAILED: {
      return { ...state, productDetail: {} };
    }

    // PRODUCT OFFERS
    case ACTION_TYPES.REQUEST_PRODUCT_OFFERS: {
      return state;
    }

    case ACTION_TYPES.REQUEST_PRODUCT_OFFERS_SUCCEEDED: {
      return { ...state, productOffers: action.payload };
    }

    case ACTION_TYPES.REQUEST_PRODUCT_OFFERS_FAILED: {
      return state;
    }

    case ACTION_TYPES.REQUEST_PRODUCT_OFFERS_CREATE_SUCCEEDED: {
      return { ...state, productOffer: action.payload };
    }

    case ACTION_TYPES.REQUEST_PRODUCT_OFFERS_CREATE_FAILED: {
      return { ...state, productOffer: {} };
    }

    // LOGOUT
    case ACTION_TYPES.REQUEST_LOGOUT_SUCCEEDED: {
      return INITIAL_STATE.product;
    }

    default:
      return state;
  }
}
